import { createContext } from 'react';

export type ReportConfigModalContextType = {
  workspaceId: string;
  prototypeId?: string;
  reportType: 'figma' | 'vibe';
  mode?: 'admin' | 'report';
};

export const ReportConfigModalContext =
  createContext<ReportConfigModalContextType>({
    workspaceId: '',
    prototypeId: undefined,
    reportType: 'figma',
    mode: 'report',
  });
